module.exports = __webpack_public_path__ + "media/images/lb/116-8a5883fade85050eb9b753aa23fa071e.svg";